import { gql } from "@apollo/client/core";

export default gql`
    query AiDocumentsQuery {
        getEntityRepositoryFiles(type: "ai_context") {
            _id
            ...aiDocumentsRepositoryFilesQuery
        }

        getCategories {
            _id
            slug

            subcategories {
                _id
                slug
            }
        }

        entityLocationSummaries {
            _id
            name
        }

    }

    fragment aiDocumentsRepositoryFilesQuery on RepositoryFile {
        _id
        filename
        createdAt

        relatedTopicSlugs
        relatedProjects {
            _id
            name
        }

        entity {
            _id
            name
        }
    }
`;
